import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyBDgjMr9GRx3BqUfgB7-8r95MvuIKjUx8g",
  authDomain: "happyeverafter-5f7d9.firebaseapp.com",
  databaseURL:
    "https://happyeverafter-5f7d9-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "happyeverafter-5f7d9",
  storageBucket: "happyeverafter-5f7d9.appspot.com",
  messagingSenderId: "763249923805",
  appId: "1:763249923805:web:dad4278de227ab77f86d34",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
